var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"img-fluid",style:({ objectPosition: ((_vm.convertToPercent(_vm.focalPoint ? _vm.focalPoint.left : 0.5)) + " " + (_vm.convertToPercent(_vm.focalPoint ? _vm.focalPoint.top : 0.5))) }),attrs:{"src":_vm.src,"srcset":_vm.srcset}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fe4156c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/ResponsiveImage.vue
// module id = 37
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18